import { MDBRow, MDBCol, MDBChip, MDBIcon } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { getLocalizedText } from '../../utils/localizedText';

export default function TopicsDisplay({
  topics,
  topicGroups,
  selectedTopics,
  unknownTopicNames = {},
  readOnly = false,
  onRemoveTopic,
}) {
  const { t, i18n } = useTranslation();

  if (!topics?.length || !topicGroups?.length || !selectedTopics?.length) {
    return null;
  }

  const sortedTopics = [];
  const unknownTopicIds = [];

  selectedTopics.forEach((selectedTopic) => {
    const topicData = topics.find((topic) => topic.id === selectedTopic);
    if (!topicData) {
      unknownTopicIds.push(selectedTopic);
      return;
    }
    const topicGroup = topicGroups.find((tg) => tg.id === topicData.topicGroupTopicsId);
    const groupIndex = sortedTopics.findIndex((st) => st.id === topicGroup.id);
    if (groupIndex === -1) {
      sortedTopics.push({ ...topicGroup, topics: [topicData] });
    } else {
      sortedTopics[groupIndex].topics.push(topicData);
    }
  });

  return (
    <MDBRow className="my-2">
      {unknownTopicIds.length > 0 && (
        <MDBCol size="12" className="mb-3">
          <div className="d-flex flex-wrap gap-1">
            {unknownTopicIds.map((id) => (
              <MDBChip key={id} className="m-0 d-flex align-items-center bg-warning text-dark">
                <MDBIcon fas icon="exclamation-triangle" className="me-1" />
                {unknownTopicNames[id] ? getLocalizedText(unknownTopicNames[id]) : t("Unknown topic")} — {t("not available in this industry")}
                {!readOnly && (
                  <MDBIcon fas icon="times" className="ms-2 cursor-pointer" onClick={() => onRemoveTopic?.(id)} />
                )}
              </MDBChip>
            ))}
          </div>
        </MDBCol>
      )}
      {sortedTopics.map((topicGroup) => (
        <MDBCol size="12" xxl="6" key={topicGroup.id} className="mb-3 mb-lg-4">
          <h6>{topicGroup.name?.find(n => n.language === i18n.language)?.text || topicGroup.name?.[0]?.text}</h6>
          <MDBRow>
            {topicGroup.topics.map((topic) => (
              <MDBCol size="12" key={topic.id}>
                <MDBChip className={`m-1 float-start bg-${topicGroup.color}`}>
                  {topic?.name?.find((name) => name.language === i18n.language)?.text || topic.name[0]?.text}
                </MDBChip>
              </MDBCol>
            ))}
          </MDBRow>
        </MDBCol>
      ))}
    </MDBRow>
  );
}
